// Axios global JWT token injection
import axios from 'axios';
import { API_BASE_URL } from './constants';

axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Axios response interceptor for automatic token refresh
axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      const refresh = localStorage.getItem('refresh');
      if (refresh) {
        originalRequest._retry = true;
        try {
          const res = await axios.post(`${API_BASE_URL}/api/token/refresh/`, { refresh });
          localStorage.setItem('token', res.data.access);
          if (res.data.refresh) {
            localStorage.setItem('refresh', res.data.refresh);
          }
          originalRequest.headers['Authorization'] = `Bearer ${res.data.access}`;
          return axios(originalRequest);
        } catch (refreshError) {
          localStorage.removeItem('token');
          localStorage.removeItem('refresh');
          window.location.href = '/login';
        }
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Proactive token refresh every 5 minutes
setInterval(async () => {
  const refresh = localStorage.getItem('refresh');
  if (refresh) {
    try {
      const res = await axios.post(`${API_BASE_URL}/api/token/refresh/`, { refresh });
      localStorage.setItem('token', res.data.access);
      if (res.data.refresh) {
        localStorage.setItem('refresh', res.data.refresh);
      }
    } catch (err) {
      localStorage.removeItem('token');
      localStorage.removeItem('refresh');
      window.location.href = '/login';
    }
  }
}, 5 * 60 * 1000); // 5 minutes
